<text mat-dialog-title>{{ data.title }}</text>
<div mat-dialog-actions align="end">
    <button mat-raised-button color="accent" (click)="updateSW()">
        {{ data.confirm ?? 'Jetzt Aktualisieren' }}
    </button>
    <button mat-raised-button (click)="closeDialog()">
        {{ data.cancel ?? 'Später erinnern' }}
    </button>
</div>
